import { FC, MouseEventHandler } from 'react';

import { IconCornerRightDown } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';

import { HeadingItem } from '@/utils/document-utils';
import { cn } from '@/utils/tailwind';

interface TableOfContentsProps {
  tocItems?: HeadingItem[];
  handleClick?: MouseEventHandler<HTMLAnchorElement>;
  language: string;
  className?: string;
}

const TableOfContents: FC<TableOfContentsProps> = ({
  tocItems = [],
  handleClick,
  language,
  className,
}) => {
  const { i18n } = useTranslation();

  const transString = i18n.getFixedT(language);
  const onThisPageTrans = transString('Generic.onThisPage');

  return (
    <ul
      className={cn(
        'w-full list-none px-5 pt-14 pb-10 md:pl-10 lg:pt-[72px] lg:pr-10 lg:pb-10',
        'lg:sticky lg:top-[104px] lg:h-fit lg:max-h-[75%] lg:overflow-scroll lg:[&::-webkit-scrollbar]:hidden',
        className,
      )}
    >
      <Typography className="text-brand-navy! mb-2! text-xl! font-bold!">
        {onThisPageTrans}
      </Typography>

      {tocItems.map((item, index) => (
        <li key={`${index}-${item.id}`} className="mb-2 cursor-pointer">
          <a
            href={`#${item.id}`}
            className="text-brand-navy! flex items-start no-underline hover:underline"
            onClick={handleClick}
          >
            <IconCornerRightDown
              className="mr-2 size-4 shrink-0 translate-y-[3px]"
              aria-hidden
            />
            {item.text}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default TableOfContents;
